import React, { useEffect, useState } from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

let months = ["January", "February", "March", "April", "May", "June",
"July", "August", "September", "October", "November", "December"
];

const Notification = (props) => {
    const [effectTimer, setEffectTimer] = useState(1);
    const [transition, setTransition] = useState('');

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
            setEffectTimer(effectTimer => effectTimer + 1);
            if (effectTimer === 1)
                resetEffect();
        }, 500);
        return ()=> clearInterval(interval);
    }, [transition, effectTimer]);

    const resetEffect=()=>{
        setEffectTimer(0);
        setTransition('');
    }

    const handleDimiss=()=>{
        setTransition('slideOutRight');
        props.dismissNewUserCount(props.user.user_id, props.field);
        setTransition('slideInUp');
    }

    return (
        <ClickAwayListener onClickAway={() => { }}>
            <div className={`panel-notification shadow-l ${transition}`}>
                <div className={'panel-notification-container'}>
                    <div className={'panel-notification-left pn-child'}>

                        <img src={require('../../assets/icons/user-profile.png')} />
                    </div>
                    <div className={'panel-notification-center pn-child'}>
                        <div className={"panel-n-title"}>{props.title}</div>
                        <div className={"panel-n-content"}>
                            {
                             (props.subtitle.length > 1) ?
                                <>{props.subtitle[0]} <b style={{color:'#2563EB', cursor:'pointer'}} data-title={props.subtitle[10]}>{props.subtitle[1]} {props.subtitle[2]}</b> {props.subtitle[3]} <b>{months[props.subtitle[4]]} {props.subtitle[5]}, {props.subtitle[6]}</b> {props.subtitle[7]} <b>{props.subtitle[8] % 12 !== 0 ? props.subtitle[8] % 12 : 12}:{props.subtitle[9] < 10 ? '0'+props.subtitle[9] : props.subtitle[9]} {(props.subtitle[8] >= 12 ? 'pm' : 'am')}</b></>
                                :
                                <>{props.subtitle[0]}</>
                            }                            
                        </div>
                        <div>
                            <a variant="text" className={"btn-view"} onClick={() => props.updateNewUserCount()} >
                                View
                            </a>
                            <a variant="text" className={"btn-dissmis"} onClick={handleDimiss} >
                                Dismiss
                            </a>
                        </div>
                    </div>
                    {/* <div className={'panel-notification-right pn-child'}>
                        <img src={require('../../assets/icons/close.png')} style={{ cursor: 'pointer' }} onClick={() => { props.setShowNotification(false) }} />
                    </div> */}
                </div>
            </div>
        </ClickAwayListener>
    );
}

export default Notification;